import { jsxs as t, jsx as r } from "react/jsx-runtime";
import { MenuItem as n } from "./MenuItem.js";
const c = ({
  label: m,
  selectedItems: e,
  disabled: a,
  onRemove: j
}) => /* @__PURE__ */ t("div", { className: "jm-flex jm-flex-col jm-gap-1", children: [
  /* @__PURE__ */ r("span", { className: "jm-font-label jm-cursor-default jm-text-jutro-new-warm-gray-800", children: m }),
  /* @__PURE__ */ r("div", { className: "jm-box-border jm-flex jm-max-h-[296px] jm-flex-col jm-gap-1 jm-overflow-y-auto jm-rounded jm-border jm-border-solid jm-border-jutro-new-warm-gray-200 jm-p-2", children: e.length ? e.map((l, o) => /* @__PURE__ */ r(
    n,
    {
      option: l,
      onRemove: j,
      disabled: a
    },
    o
  )) : /* @__PURE__ */ r("div", { className: "jm-grid jm-place-items-center", children: /* @__PURE__ */ r("span", { className: "jm-font-paragraph-1 jm-text-jutro-new-warm-gray-600", children: "Wybierz elementy z listy" }) }) })
] });
export {
  c as ItemsArea
};
//# sourceMappingURL=ItemsArea.js.map
